export const replacePageMetaTemplatesWithVariable = ({
  data = {},
  input,
  appInput = {}
}) => {
  let text = JSON.stringify(data);
  const regex = /\[(?:\[??([^[]*?)\]\])/g; // find all occurences of templates

  const matches = [];
  let result = regex.exec(text);

  while (result != null) {
    matches.push(result[1]);
    result = regex.exec(text);
  } // for each template replace with input variables


  matches.forEach(match => {
    const template = match.split('|');
    const varType = template[0];
    const varName = template[1]; // to prevent import cycle we hardcode shortcode list

    if (['low-price', 'low-price-from-choice', 'average-price', 'default-form-quantity', 'side-effects', 'interactions', 'drawer', 'promo'].find(shortcode => match.startsWith(shortcode))) {
      // do not modify shortcode text
      return;
    }

    const inputVar = varType === 'EDITOR' ? input[varName] : appInput[varName];

    if (typeof inputVar === 'string') {
      let stringInputVar; // additional string manipulation [['EDITOR|DRUG_DISPLAY_NAME|||title']] or [['EDITOR|DRUG_DISPLAY_NAME|||lower']]

      switch (template[4]) {
        case 'lower':
          stringInputVar = inputVar.toLowerCase();
          break;

        case 'title':
          stringInputVar = inputVar.charAt(0).toUpperCase() + inputVar.slice(1);
          break;

        default:
          stringInputVar = inputVar;
      }

      text = text.replace(`[[${match}]]`, stringInputVar);
    } else if (Array.isArray(inputVar)) {
      const arrInputBar = JSON.stringify(inputVar);
      text = text.replace(`"[[${match}]]"`, arrInputBar);
    } else {
      text = text.replace(`[[${match}]]`, '');
    }
  });
  text = text.replace(/\s+/g, ' ');
  return JSON.parse(text);
};